import { render, staticRenderFns } from "./SfAlert.vue?vue&type=template&id=ab5bb2fe&scoped=true&"
import script from "./SfAlert.vue?vue&type=script&lang=ts&"
export * from "./SfAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5bb2fe",
  null
  
)

export default component.exports